<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Einander kennenlernen</h1>
                <p class="h2">Die ersten Tage in der Vitadio-App dienen dem gegenseitigen Kennenlernen</p>
            </div>
            <div class="right-wrapper">
                <h2>Tägliche Anleitung</h2>
                <p class="text">Der oder die Nutzende folgt einer anpassbaren Aufgabenliste, die sich mit den Entscheidungen und Fortschritten innerhalb des Programms weiterentwickelt.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 12
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

